/**
 * This module will operate as the central gateway into using the i18n-formatting library
 * in Dojo.
 */
define(["vendor/i18n-formatting/i18nformatting"], function (i18nFormattingModule) {
  var i18nFormatting = i18nFormattingModule;
  return i18nFormatting;
});